import { useLayoutEffect, useMemo } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Helmet } from "react-helmet-async";
import {
  blogListPath,
  blogPostPath,
  blogAbsoluteUrl,
} from "@/lib/blog";

const seoData = {
  tr: {
    home: {
      title: "B2B Bayi Yönetim Sistemi | EntegrePanel - Teklif, Sipariş, Bayi Portalı",
      description: "EntegrePanel B2B bayi yönetim sistemi: Teklif, sipariş, bayi portalı, tedarikçi, ön muhasebe ve CRM tek panelde. Mobilya sektörüne özel. Ücretsiz deneyin.",
      keywords: "B2B bayi yönetim sistemi, bayi yönetim yazılımı, bayi portalı, teklif yönetimi yazılımı, sipariş takip sistemi, entegre tedarikçi yönetimi, B2B sipariş portalı, ön muhasebe yazılımı, mobilya B2B, CRM saha satış, şube yönetimi, fiyat listesi yönetimi, WhatsApp teklif gönderme, çoklu döviz teklif",
    },
    features: {
      title: "Özellikler | B2B Bayi Yönetim Yazılımı - Teklif, Sipariş, CRM, Ön Muhasebe",
      description: "EntegrePanel özellikleri: Çoklu döviz teklif, sipariş takibi, bayi portalı, entegre tedarikçi, B2B CRM, ön muhasebe ve detaylı raporlar. Tek panelden yönetin.",
      keywords: "teklif yönetimi, sipariş yönetimi, bayi yönetimi özellikleri, B2B CRM, entegre tedarikçi, ön muhasebe, fiyat listesi, satış sonrası hizmet SSH, bayi performans takibi, çoklu döviz, mobilya sektörü yazılım",
    },
    pricing: {
      title: "Fiyatlandırma | B2B Bayi Yönetim Sistemi Paketleri - Ücretsiz Başlayın",
      description: "EntegrePanel fiyatları: Ücretsiz ($0), Başlangıç ($100/yıl), Pro ($300/yıl), Business ($750/yıl). Sınırsız kullanıcı, bayi portalı, teklif & sipariş dahil.",
      keywords: "B2B bayi yönetim sistemi fiyatları, bayi yazılımı fiyat, EntegrePanel paketleri, ücretsiz bayi yönetim, bayi portalı fiyat",
    },
    contact: {
      title: "İletişim & Ücretsiz Demo | B2B Bayi Yönetim Sistemi EntegrePanel",
      description: "EntegrePanel B2B bayi yönetim sistemi demo randevusu alın. Tel: 0224 718 54 00, WhatsApp: +90 533 163 16 34. Bursa, Türkiye merkezli ekibimizle iletişime geçin.",
      keywords: "EntegrePanel demo, bayi yönetim sistemi demo, B2B yazılım iletişim, ücretsiz demo randevu, Bursa B2B yazılım",
    },
    faq: {
      title: "SSS | B2B Bayi Yönetim Sistemi Hakkında Sıkça Sorulan Sorular",
      description: "EntegrePanel B2B bayi yönetim sistemi SSS: Teklif yönetimi nasıl çalışır, bayi portalı nedir, hangi platformlarda kullanılır, fiyatlar ve güvenlik bilgileri.",
      keywords: "EntegrePanel nedir, bayi yönetim sistemi SSS, teklif yönetimi nasıl çalışır, B2B yazılım sorular",
    },
    privacy: {
      title: "Gizlilik Politikası | EntegrePanel - KVKK Kapsamında Veri Koruma",
      description: "EntegrePanel gizlilik politikası: KVKK kapsamında topladığımız veriler, işleme amaçları, saklama süreleri ve veri sahibi haklarınız hakkında detaylı bilgi.",
      keywords: "EntegrePanel gizlilik politikası, KVKK, kişisel veri koruma, veri sahibi hakları, çerez politikası, KVKK aydınlatma metni",
    },
    terms: {
      title: "Kullanım Koşulları | EntegrePanel B2B Bayi Yönetim Sistemi",
      description: "EntegrePanel kullanım koşulları: Hizmet tanımı, üyelik şartları, kullanıcı yükümlülükleri, ödeme ve iptal politikası, fikri mülkiyet hakları.",
      keywords: "EntegrePanel kullanım koşulları, hizmet şartları, kullanıcı sözleşmesi, B2B SaaS şartları, üyelik şartları",
    },
    blog: {
      title: "Blog | EntegrePanel - B2B Bayi Yönetimi, Entegrasyon ve Yazılım İpuçları",
      description: "EntegrePanel blog: B2B bayi yönetimi, teklif sistemi, entegrasyon ipuçları, ürün güncellemeleri ve sektör haberleri. Haftalık güncel içerik.",
      keywords: "B2B blog, bayi yönetim ipuçları, entegrasyon, ERP blog, CRM ipuçları, mobilya B2B blog, EntegrePanel haberleri",
    },
  },
  en: {
    home: {
      title: "B2B Dealer Management System | EntegrePanel - Quote, Order & Dealer Portal",
      description: "EntegrePanel B2B dealer management software: Create quotes, track orders, manage dealers, suppliers, pre-accounting & CRM in one panel. Start free.",
      keywords: "B2B dealer management system, dealer management software, dealer portal, quote management software, order tracking system, supplier integration, B2B order portal, pre-accounting software, furniture B2B, CRM field sales, branch management",
    },
    features: {
      title: "Features | B2B Dealer Management Software - Quote, Order, CRM, Accounting",
      description: "EntegrePanel features: Multi-currency quotes (TRY, USD, EUR, GBP), order tracking, dealer portal, integrated supplier system, B2B CRM, pre-accounting & analytics.",
      keywords: "quote management, order management, dealer management features, B2B CRM, integrated supplier, pre-accounting, price list management, after-sales service, dealer performance tracking",
    },
    pricing: {
      title: "Pricing | B2B Dealer Management System Plans - Start Free",
      description: "EntegrePanel pricing: Free ($0), Starter ($100/yr), Pro ($300/yr), Business ($750/yr). Unlimited users, dealer portal, quote & order management included.",
      keywords: "B2B dealer management pricing, dealer software price, EntegrePanel plans, free dealer management",
    },
    contact: {
      title: "Contact & Free Demo | B2B Dealer Management System EntegrePanel",
      description: "Schedule a free EntegrePanel B2B dealer management demo. Phone: +90 224 718 54 00, WhatsApp: +90 533 163 16 34. Bursa, Türkiye based team.",
      keywords: "EntegrePanel demo, dealer management system demo, B2B software contact, free demo booking",
    },
    faq: {
      title: "FAQ | B2B Dealer Management System Frequently Asked Questions",
      description: "EntegrePanel FAQ: How quote management works, what is a dealer portal, supported platforms, pricing details and security information for B2B users.",
      keywords: "EntegrePanel FAQ, dealer management system questions, B2B software FAQ, quote management how to",
    },
    privacy: {
      title: "Privacy Policy | EntegrePanel - Data Protection Under KVKK",
      description: "EntegrePanel privacy policy: Data we collect, processing purposes, retention periods, and your data subject rights under the Turkish Personal Data Protection Law (KVKK).",
      keywords: "EntegrePanel privacy policy, KVKK, personal data protection, data subject rights, cookie policy, GDPR",
    },
    terms: {
      title: "Terms of Service | EntegrePanel B2B Dealer Management System",
      description: "EntegrePanel terms of service: Service description, membership conditions, user obligations, payment and cancellation policy, intellectual property rights.",
      keywords: "EntegrePanel terms of service, terms and conditions, user agreement, B2B SaaS terms, membership terms",
    },
    blog: {
      title: "Blog | EntegrePanel - B2B Dealer Management, Integrations & Software Tips",
      description: "EntegrePanel blog: B2B dealer management, quote system, integration tips, product updates and industry news. Weekly fresh content.",
      keywords: "B2B blog, dealer management tips, integration, ERP blog, CRM tips, furniture B2B blog, EntegrePanel news",
    },
  },
  ar: {
    home: {
      title: "نظام إدارة الوكلاء B2B | EntegrePanel - العروض والطلبات وبوابة الوكلاء",
      description: "برنامج EntegrePanel لإدارة الوكلاء B2B: عروض الأسعار، تتبع الطلبات، بوابة الوكلاء، الموردون، المحاسبة وCRM في لوحة واحدة. ابدأ مجاناً.",
      keywords: "نظام إدارة الوكلاء B2B, برنامج إدارة الوكلاء, بوابة الوكلاء, نظام عروض الأسعار, تتبع الطلبات, تكامل الموردين, بوابة طلبات B2B, محاسبة أولية, أثاث B2B, CRM مبيعات ميدانية, إدارة الفروع",
    },
    features: {
      title: "الميزات | برنامج إدارة الوكلاء B2B - العروض والطلبات وCRM والمحاسبة",
      description: "ميزات EntegrePanel: عروض أسعار متعددة العملات، تتبع الطلبات، بوابة الوكلاء، موردون متكاملون، CRM، محاسبة أولية وتقارير تحليلية متقدمة.",
      keywords: "إدارة العروض, إدارة الطلبات, ميزات إدارة الوكلاء, CRM B2B, موردين متكاملين, محاسبة أولية, قوائم الأسعار",
    },
    pricing: {
      title: "الأسعار | باقات نظام إدارة الوكلاء B2B - ابدأ مجاناً",
      description: "أسعار EntegrePanel: مجانية ($0)، بداية ($100/سنة)، احترافي ($300/سنة)، أعمال ($750/سنة). مستخدمون غير محدودون مع بوابة الوكلاء.",
      keywords: "أسعار نظام إدارة الوكلاء, سعر برنامج الوكلاء B2B, باقات EntegrePanel, إدارة وكلاء مجانية",
    },
    contact: {
      title: "اتصل بنا وعرض تجريبي مجاني | نظام إدارة الوكلاء B2B EntegrePanel",
      description: "احجز عرضاً تجريبياً مجانياً لنظام EntegrePanel B2B. هاتف: +90 224 718 54 00، واتساب: +90 533 163 16 34. فريقنا في بورصة، تركيا.",
      keywords: "عرض تجريبي EntegrePanel, نظام إدارة الوكلاء عرض, برنامج B2B اتصال, حجز عرض تجريبي مجاني",
    },
    faq: {
      title: "الأسئلة الشائعة | نظام إدارة الوكلاء B2B - EntegrePanel",
      description: "أسئلة شائعة حول EntegrePanel: كيف تعمل إدارة العروض، ما هي بوابة الوكلاء، المنصات المدعومة، تفاصيل الأسعار والأمان لمستخدمي B2B.",
      keywords: "أسئلة EntegrePanel, أسئلة نظام إدارة الوكلاء, أسئلة برنامج B2B, كيف تعمل إدارة العروض",
    },
    privacy: {
      title: "سياسة الخصوصية | EntegrePanel - حماية البيانات بموجب KVKK",
      description: "سياسة خصوصية EntegrePanel: البيانات التي نجمعها، أغراض المعالجة، فترات الاحتفاظ وحقوقك كصاحب بيانات بموجب قانون حماية البيانات الشخصية التركي.",
      keywords: "سياسة خصوصية EntegrePanel, KVKK, حماية البيانات الشخصية, حقوق صاحب البيانات, سياسة ملفات تعريف الارتباط",
    },
    terms: {
      title: "شروط الخدمة | نظام إدارة الوكلاء B2B EntegrePanel",
      description: "شروط خدمة EntegrePanel: وصف الخدمة، شروط العضوية، التزامات المستخدم، سياسة الدفع والإلغاء، حقوق الملكية الفكرية.",
      keywords: "شروط خدمة EntegrePanel, الشروط والأحكام, اتفاقية المستخدم, شروط SaaS B2B, شروط العضوية",
    },
    blog: {
      title: "المدونة | EntegrePanel - إدارة الوكلاء B2B والتكاملات ونصائح البرامج",
      description: "مدونة EntegrePanel: إدارة الوكلاء B2B، نظام عروض الأسعار، نصائح التكامل، تحديثات المنتج وأخبار الصناعة. محتوى أسبوعي محدّث.",
      keywords: "مدونة B2B, نصائح إدارة الوكلاء, التكامل, مدونة ERP, نصائح CRM, مدونة أثاث B2B, أخبار EntegrePanel",
    },
  },
};

// Statik sayfa rotaları (mevcut)
const routeMap = {
  tr: {
    home: "/",
    features: "/ozellikler",
    pricing: "/fiyatlandirma",
    faq: "/sss",
    contact: "/iletisim",
    privacy: "/gizlilik-politikasi",
    terms: "/kullanim-kosullari",
  },
  en: {
    home: "/en",
    features: "/features",
    pricing: "/pricing",
    faq: "/faq",
    contact: "/contact",
    privacy: "/privacy-policy",
    terms: "/terms-of-service",
  },
  ar: {
    home: "/ar",
    features: "/ar/ozellikler",
    pricing: "/ar/fiyatlandirma",
    faq: "/ar/sss",
    contact: "/ar/iletisim",
    privacy: "/ar/gizlilik-politikasi",
    terms: "/ar/kullanim-kosullari",
  },
};

const baseUrl = "https://entegrepanel.net";
const langLocaleMap = { tr: "tr_TR", en: "en_US", ar: "ar_SA" };

function buildUrl(lang, page) {
  // Blog rotaları için lib/blog'a delege et
  if (page === "blog") return blogAbsoluteUrl(blogListPath(lang));
  const path = routeMap[lang]?.[page] || "/";
  return `${baseUrl}${path === "/" ? "" : path}${path === "/" ? "/" : ""}`;
}

function escapeHtmlForJsonLd(str) {
  if (!str) return "";
  return String(str).replace(/"/g, '\\"').replace(/\n/g, " ").replace(/\s+/g, " ").trim();
}

/**
 * SEOHead — statik sayfalar + dinamik blog detay desteği.
 *
 * Statik sayfalar:
 *   <SEOHead page="home" />, <SEOHead page="blog" />
 *
 * Blog detay (dinamik):
 *   <SEOHead page="blog-detail" lang={lang} article={post} />
 *
 * Override:
 *   <SEOHead page="blog" titleOverride="Kategori Adı" />
 */
export function SEOHead({ page = "home", article = null, lang: langProp = null, titleOverride = null }) {
  const { lang: ctxLang } = useLanguage();
  const lang = langProp || ctxLang;

  // Dinamik veri (blog detay)
  const { data, currentUrl, hreflangs, ogImage, jsonLd } = useMemo(() => {
    if (page === "blog-detail" && article) {
      const title = (article.seo_title || article.title) + " | Entegrepanel Blog";
      const description = article.seo_description || article.excerpt || "";
      const keywords = article.seo_keywords || (Array.isArray(article.tags) ? article.tags.join(", ") : "");
      const url = blogAbsoluteUrl(blogPostPath(lang, article.slug));
      const img = article.featured_image || `${baseUrl}/images/og-image.png`;

      // hreflangs — diğer dillerdeki çevirilerden
      const hLangs = {
        "x-default": url,
      };
      (article.translations || []).forEach((tr) => {
        if (tr.is_published) {
          hLangs[tr.language] = blogAbsoluteUrl(blogPostPath(tr.language, tr.slug));
        }
      });
      hLangs[lang] = url;

      const jsonLdObj = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: article.title,
        description: description,
        image: img,
        datePublished: article.published_at,
        dateModified: article.updated_at || article.published_at,
        inLanguage: lang,
        mainEntityOfPage: url,
        publisher: {
          "@type": "Organization",
          name: "EntegrePanel",
          logo: {
            "@type": "ImageObject",
            url: `${baseUrl}/images/entegrelogo/EP-Logo-Normal.svg`,
          },
        },
        ...(article.category_name && { articleSection: article.category_name }),
        ...(Array.isArray(article.tags) && article.tags.length > 0 && { keywords: article.tags.join(", ") }),
      };

      return {
        data: { title, description, keywords },
        currentUrl: url,
        hreflangs: hLangs,
        ogImage: img,
        jsonLd: jsonLdObj,
      };
    }

    // Statik sayfa
    const staticData = seoData[lang]?.[page] || seoData.tr[page] || seoData.tr.home;
    const finalTitle = titleOverride
      ? `${titleOverride} | Entegrepanel Blog`
      : staticData.title;
    const url = buildUrl(lang, page);
    return {
      data: { ...staticData, title: finalTitle },
      currentUrl: url,
      hreflangs: {
        tr: buildUrl("tr", page),
        en: buildUrl("en", page),
        ar: buildUrl("ar", page),
        "x-default": buildUrl("tr", page),
      },
      ogImage: `${baseUrl}/images/og-image.png`,
      jsonLd: null,
    };
  }, [page, article, lang, titleOverride]);

  const alternateLocales = Object.entries(langLocaleMap)
    .filter(([code]) => code !== lang)
    .map(([, locale]) => locale);

  // Prerender bypass (Helmet eksikliklerini telafi eden global SEO objesi)
  useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      window.__PRERENDER_SEO__ = {
        lang,
        dir: lang === "ar" ? "rtl" : "ltr",
        title: data.title,
        description: data.description,
        keywords: data.keywords,
        canonical: currentUrl,
        ogTitle: data.title,
        ogDescription: data.description,
        ogUrl: currentUrl,
        ogLocale: langLocaleMap[lang],
        alternateLocales,
        ogImage: ogImage,
        ogType: page === "blog-detail" ? "article" : "website",
        twitterTitle: data.title,
        twitterDescription: data.description,
        twitterImage: ogImage,
        hreflangs: {
          tr: hreflangs.tr || hreflangs[lang],
          en: hreflangs.en || hreflangs[lang],
          ar: hreflangs.ar || hreflangs[lang],
          "x-default": hreflangs["x-default"],
        },
        jsonLd: jsonLd ? JSON.stringify(jsonLd) : null,
      };
    }
  }, [lang, page, data, currentUrl, hreflangs, ogImage, jsonLd, alternateLocales]);

  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <meta name="author" content="Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ - UR-GE Yazılım" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={page === "blog-detail" ? "article" : "website"} />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="EntegrePanel" />
      <meta property="og:locale" content={langLocaleMap[lang]} />
      {alternateLocales.map((locale) => (
        <meta key={locale} property="og:locale:alternate" content={locale} />
      ))}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />

      {/* Article-specific OG */}
      {page === "blog-detail" && article && (
        <>
          {article.published_at && <meta property="article:published_time" content={article.published_at} />}
          {article.updated_at && <meta property="article:modified_time" content={article.updated_at} />}
          {article.category_name && <meta property="article:section" content={article.category_name} />}
          {Array.isArray(article.tags) && article.tags.map((tag) => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Hreflang */}
      {hreflangs.tr && <link rel="alternate" hrefLang="tr" href={hreflangs.tr} />}
      {hreflangs.en && <link rel="alternate" hrefLang="en" href={hreflangs.en} />}
      {hreflangs.ar && <link rel="alternate" hrefLang="ar" href={hreflangs.ar} />}
      {hreflangs["x-default"] && <link rel="alternate" hrefLang="x-default" href={hreflangs["x-default"]} />}

      {/* JSON-LD (blog detay) */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
